import AdminViewWrapper from './view';

export default AdminViewWrapper;
